import { lazy } from "react";
export const Team = lazy(() => import(/* webpackChunkName: "Team" */ './Team'));
